export interface VirtualWindowInput {
  totalItems: number;
  scrollTop: number;
  viewportHeight: number;
  rowHeight: number;
  overscan: number;
}

export interface VirtualWindow {
  startIndex: number;
  endIndex: number;
  offsetTop: number;
  totalHeight: number;
}

export function getVirtualWindow(input: VirtualWindowInput): VirtualWindow {
  const totalHeight = input.totalItems * input.rowHeight;
  const firstVisibleIndex = Math.floor(input.scrollTop / input.rowHeight);
  const visibleCount = Math.ceil(input.viewportHeight / input.rowHeight);
  const startIndex = clamp(firstVisibleIndex - input.overscan, 0, input.totalItems);
  const endIndex = clamp(firstVisibleIndex + visibleCount + input.overscan, startIndex, input.totalItems);

  return {
    startIndex,
    endIndex,
    offsetTop: startIndex * input.rowHeight,
    totalHeight
  };
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
